import React from 'react';
import PropTypes from 'prop-types';

import {
    ResponsiveContainer,
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
} from 'recharts';

import GraphTitle from 'app/shared/components/Graphs/GraphTitle';
import GraphEmptyMessage from 'app/shared/components/Graphs/GraphEmptyMessage';
import SpinnerContainer from 'app/shared/components/SpinnerContainer';

import GraphConstants from 'app/shared/constants/GraphConstants';

// Stylesheets
import 'app/shared/components/Graphs/style.scss';

const propTypes = {
    brand: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    showTabs: PropTypes.bool,
};

const defaultProps = {
    isLoading: false,
    showTabs: false,
};

const GRAPH = GraphConstants.GRAPHS.VIEW;
const TABS = GraphConstants.GRAPH_TABS;
const dataKey = GraphConstants.GRAPH_DATA_TYPES.VIEWS;

class ViewGraph extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: props.showTabs ? TABS.AVERAGE : TABS.DEFAULT,
        };
        this.handleTabClick = this.handleTabClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!this.props.showTabs && prevProps.showTabs) {
            this.setState({ activeTab: TABS.DEFAULT });
        }
    }

    handleTabClick(index) {
        this.setState({ activeTab: index === 0 ? TABS.AVERAGE : TABS.TOTAL });
    }

    renderGraph(currentData) {
        const { brand } = this.props;
        return (
            <div className="Graph-container">
                {currentData.isEmpty && <GraphEmptyMessage message="No views available" />}
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={currentData.months} key={dataKey}>
                        <XAxis dataKey="name" />
                        <YAxis />
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <Tooltip />
                        <Line
                            dataKey={dataKey}
                            stroke={GraphConstants.COLORS[brand].secondary}
                            dot={{ r: 5, fill: GraphConstants.COLORS[brand].secondary }}
                            activeDot={{ r: 8 }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        );
    }

    render() {
        const {
            isLoading,
            showTabs,
            data,
        } = this.props;
        const { activeTab } = this.state;
        const configs = GRAPH[activeTab];
        const currentData = isLoading ? 0 : data[configs.DATA_TYPE];
        const title = `${configs.TITLE_PREFIX}: ${currentData[dataKey] || '-'}`;

        return (
            <div className="Graph">
                <GraphTitle
                    title={title}
                    isLoading={isLoading}
                    showTabs={showTabs}
                    onTabClick={this.handleTabClick}
                    activeIndex={configs.TAB_INDEX}
                />
                {isLoading ? <SpinnerContainer customClass="Graph-Spinner" /> : this.renderGraph(currentData)}
            </div>
        );
    }
}

ViewGraph.propTypes = propTypes;
ViewGraph.defaultProps = defaultProps;

export default ViewGraph;
